import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { key: 3 }

import CoreUiClientInfoRowValueInterface from "~/core-ui/vue/chat/CoreUiClientInfoRowValueInterface";


const __default__ = {
    name: "CoreUiClientInfoRow"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.value.typeId === 'text')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(__props.value.text), 1)
        ], 64))
      : (__props.value.typeId === 'link')
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: __props.value.link,
            title: __props.value.link,
            target: "_blank"
          }, _toDisplayString(__props.value.caption ? __props.value.caption : __props.value.link), 9, _hoisted_1))
        : (__props.value.typeId === 'number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(__props.value.value), 1)
            ], 64))
          : (_openBlock(), _createElementBlock("pre", _hoisted_2, _toDisplayString(__props.value), 1))
  ]))
}
}

})